import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import EditTaxesHiboutikModal from 'components/modals/admin/EditTaxesHiboutikModal'
import EditPaymentsHiboutikModal from 'components/modals/admin/EditPaymentsHiboutikModal'
import DeleteModal from 'components/modals/common/DeleteModal'
import WarningModal from 'components/modals/common/WarningModal'
import ChangeAdminCodeModal from 'routes/Admin/Settings/components/general/ChangeAdminCodeModal'
import ReorderModal from 'components/modals/admin/ReorderModal'

import TableModal from 'routes/Admin/Tables/components/TableModal'
import ProductModal from 'routes/Admin/Products/components/ProductModal'
import CategoryModal from 'routes/Admin/Categories/components/CategoryModal'
import PricingModal from 'routes/Admin/Pricings/components/PricingModal'
import PlayerModal from 'routes/Admin/Players/components/PlayerModal'
import UserModal from 'routes/Admin/Users/components/UserModal'
import CustomerModal from 'routes/Admin/Customers/components/CustomerModal'
import LockerModal from 'routes/Admin/Lockers/components/LockerModal'
import {
  refreshTaxes,
  refreshPayments,
  changeAdminCode
} from 'redux/modules/settings'
import {
  createProduct,
  updateProduct,
  deleteProducts,
  reorderProducts
} from 'redux/modules/product'
import {
  createCategory,
  updateCategory,
  deleteCategories,
  reorderCategories
} from 'redux/modules/category'
import { createTable, updateTable, deleteTable } from 'redux/modules/table'
import {
  createPricing,
  updatePricing,
  deletePricings
} from 'redux/modules/pricing'
import {
  createPlayer,
  updatePlayer,
  deletePlayers,
  reorderPlayers
} from 'redux/modules/player'
import { updateUser } from 'redux/modules/user'
import { createCustomer, updateCustomer } from 'redux/modules/customer'
import { createLocker, updateLocker, deleteLockers } from 'redux/modules/locker'
import {
  MODAL_ADMIN_WARNING_IN_USE,
  MODAL_ADMIN_CREATE_TABLE,
  MODAL_ADMIN_EDIT_TABLE,
  MODAL_ADMIN_DELETE_TABLE,
  MODAL_ADMIN_CREATE_CATEGORY,
  MODAL_ADMIN_EDIT_CATEGORY,
  MODAL_ADMIN_DELETE_CATEGORY,
  MODAL_ADMIN_REORDER_CATEGORY,
  MODAL_ADMIN_CREATE_PRODUCT,
  MODAL_ADMIN_EDIT_PRODUCT,
  MODAL_ADMIN_DELETE_PRODUCT,
  MODAL_ADMIN_REORDER_PRODUCT,
  MODAL_ADMIN_CREATE_PRICING,
  MODAL_ADMIN_EDIT_PRICING,
  MODAL_ADMIN_DELETE_PRICING,
  MODAL_ADMIN_CREATE_PLAYER,
  MODAL_ADMIN_EDIT_PLAYER,
  MODAL_ADMIN_DELETE_PLAYER,
  MODAL_ADMIN_REORDER_PLAYER,
  MODAL_ADMIN_EDIT_TAXE,
  MODAL_ADMIN_EDIT_PAYMENT,
  MODAL_ADMIN_EDIT_USER,
  MODAL_ADMIN_CREATE_CUSTOMER,
  MODAL_ADMIN_EDIT_CUSTOMER,
  MODAL_ADMIN_CREATE_LOCKER,
  MODAL_ADMIN_EDIT_LOCKER,
  MODAL_ADMIN_DELETE_LOCKER,
  MODAL_ADMIN_CHANGE_CODE,
  hideModal
} from 'redux/modules/modals'

const mapActionCreators = {
  createTable,
  updateTable,
  deleteTable,
  createPricing,
  updatePricing,
  deletePricings,
  createPlayer,
  updatePlayer,
  deletePlayers,
  reorderPlayers,
  createCategory,
  updateCategory,
  deleteCategories,
  reorderCategories,
  createProduct,
  updateProduct,
  deleteProducts,
  reorderProducts,
  refreshTaxes,
  refreshPayments,
  updateUser,
  createCustomer,
  updateCustomer,
  createLocker,
  updateLocker,
  deleteLockers,
  changeAdminCode,
  hideModal
}
const mapStateToProps = state => {
  return {
    auth: state.auth,
    currentModal: state.modals.currentModal,
    payload: state.modals.payload,
    players: state.players.list,
    tables: state.tables.list,
    pricings: state.pricings.list,
    categories: state.categories.list,
    products: state.products.list,
    taxes: state.settings.taxes,
    customers: state.customers.list,
    lockers: state.lockers.list,
    tableTypes: state.settings.tableTypes
  }
}
const ModalConductor = props => {
  const payloadArray = _.isArray(props.payload) ? props.payload : void 0
  const payload =
    payloadArray && payloadArray.length === 1 ? payloadArray[0] : props.payload
  switch (props.currentModal) {
    case MODAL_ADMIN_WARNING_IN_USE:
      return <WarningModal item={payload} />
    case MODAL_ADMIN_CREATE_TABLE:
      const tableIds = props.tables.map(t => Number(t.num))
      return (
        <TableModal
          tableIds={tableIds}
          createTable={props.createTable}
          tableTypes={props.tableTypes}
        />
      )
    case MODAL_ADMIN_EDIT_TABLE:
      return (
        <TableModal
          table={payload}
          updateTable={props.updateTable}
          tableTypes={props.tableTypes}
        />
      )
    case MODAL_ADMIN_DELETE_TABLE:
      return <DeleteModal items={[payload]} deleteAction={props.deleteTable} />
    case MODAL_ADMIN_CREATE_CATEGORY:
      return (
        <CategoryModal
          taxes={props.taxes}
          createCategory={props.createCategory}
          categoryNames={props.categories.map(c => _.lowerCase(c.name))}
        />
      )
    case MODAL_ADMIN_EDIT_CATEGORY:
      return (
        <CategoryModal
          category={payload}
          taxes={props.taxes}
          categoryNames={props.categories.map(c => _.lowerCase(c.name))}
          updateCategory={props.updateCategory}
        />
      )
    case MODAL_ADMIN_DELETE_CATEGORY:
      return (
        <DeleteModal
          items={payloadArray}
          deleteAction={props.deleteCategories}
        />
      )
    case MODAL_ADMIN_REORDER_CATEGORY:
      return (
        <ReorderModal items={payload} onChangeOrder={props.reorderCategories} />
      )
    case MODAL_ADMIN_CREATE_PRODUCT:
      return (
        <ProductModal
          defaultCategory={payload}
          taxes={props.taxes}
          createProduct={props.createProduct}
          productNames={props.products.map(p => _.lowerCase(p.name))}
          categories={props.categories}
        />
      )
    case MODAL_ADMIN_EDIT_PRODUCT:
      return (
        <ProductModal
          product={payload}
          taxes={props.taxes}
          productNames={props.products.map(p => _.lowerCase(p.name))}
          updateProduct={props.updateProduct}
          categories={props.categories}
        />
      )
    case MODAL_ADMIN_DELETE_PRODUCT:
      return (
        <DeleteModal items={payloadArray} deleteAction={props.deleteProducts} />
      )
    case MODAL_ADMIN_REORDER_PRODUCT:
      return (
        <ReorderModal items={payload} onChangeOrder={props.reorderProducts} />
      )
    case MODAL_ADMIN_CREATE_PRICING:
      return (
        <PricingModal
          pricingNames={props.pricings.map(t => _.lowerCase(t.name))}
          createPricing={props.createPricing}
          tableTypes={props.tableTypes}
        />
      )
    case MODAL_ADMIN_EDIT_PRICING:
      return (
        <PricingModal
          pricing={payload}
          pricingNames={props.pricings.map(t => t.name)}
          updatePricing={props.updatePricing}
          tableTypes={props.tableTypes}
        />
      )
    case MODAL_ADMIN_DELETE_PRICING:
      return (
        <DeleteModal items={payloadArray} deleteAction={props.deletePricings} />
      )
    case MODAL_ADMIN_CREATE_PLAYER:
      return (
        <PlayerModal
          playerNames={props.players.map(t => _.lowerCase(t.name))}
          createPlayer={props.createPlayer}
        />
      )
    case MODAL_ADMIN_EDIT_PLAYER:
      return (
        <PlayerModal
          player={payload}
          playerNames={props.players.map(t => t.name)}
          updatePlayer={props.updatePlayer}
        />
      )
    case MODAL_ADMIN_DELETE_PLAYER:
      return (
        <DeleteModal items={payloadArray} deleteAction={props.deletePlayers} />
      )
    case MODAL_ADMIN_REORDER_PLAYER:
      return (
        <ReorderModal items={payload} onChangeOrder={props.reorderPlayers} />
      )
    case MODAL_ADMIN_EDIT_TAXE:
      return (
        <EditTaxesHiboutikModal
          title="Modifier les taxes"
          auth={props.auth}
          refreshTaxes={props.refreshTaxes}
        />
      )
    case MODAL_ADMIN_EDIT_PAYMENT:
      return (
        <EditPaymentsHiboutikModal
          title="Modifier les modes de paiement"
          auth={props.auth}
          refreshPayments={props.refreshPayments}
        />
      )
    case MODAL_ADMIN_EDIT_USER:
      return <UserModal user={payload} updateUser={props.updateUser} />
    case MODAL_ADMIN_CREATE_CUSTOMER:
      return (
        <CustomerModal
          customersNames={props.customers.map(c =>
            _.lowerCase(`${c.customers_first_name} ${c.customers_last_name}`)
          )}
          createCustomer={props.createCustomer}
        />
      )
    case MODAL_ADMIN_EDIT_CUSTOMER:
      return (
        <CustomerModal
          customer={payload}
          customersNames={props.customers.map(c =>
            _.lowerCase(`${c.customers_first_name} ${c.customers_last_name}`)
          )}
          updateCustomer={props.updateCustomer}
        />
      )
    case MODAL_ADMIN_CREATE_LOCKER:
      return (
        <LockerModal
          lockerNames={props.lockers.map(l => _.lowerCase(`${l.name}`))}
          customers={props.customers}
          createLocker={props.createLocker}
        />
      )
    case MODAL_ADMIN_EDIT_LOCKER:
      return (
        <LockerModal
          locker={payload}
          lockerNames={props.lockers.map(l => _.lowerCase(`${l.name}`))}
          customers={props.customers}
          updateLocker={props.updateLocker}
        />
      )
    case MODAL_ADMIN_DELETE_LOCKER:
      return (
        <DeleteModal items={payloadArray} deleteAction={props.deleteLockers} />
      )
    case MODAL_ADMIN_CHANGE_CODE:
      return (
        <ChangeAdminCodeModal
          changeAdminCode={props.changeAdminCode}
          hideModal={props.hideModal}
        />
      )
    default:
      return null
  }
}

export default connect(mapStateToProps, mapActionCreators)(ModalConductor)



// WEBPACK FOOTER //
// ./src/containers/AdminModalConductor.js